<script>
	// Components
	import StepInputFloat from '@/Components/StepInputFloat.svelte';
	// Services
	import { dollarsToCents, nextLadderPrice, NumberTransform } from '@/Services/Helpers.js';
	// Constants
	import { PriceLadder } from '@/Constants/Prices.js';

	export let item;
	export let width = 'w-14';
	export let onEnter = false;
	export let compact = false;
	export let tabindex;
	export let priceKey = 'price';

	window.nextLadderPrice = nextLadderPrice;
	window.PriceLadder = PriceLadder;

	let newPrice = item && item[priceKey] && NumberTransform(item[priceKey]);
	$: newPrice && calcOverride();

	function calcOverride() {
		item[priceKey] = dollarsToCents(newPrice);
	}

	function setClosest(direction) {
		try {
			newPrice = nextLadderPrice(newPrice, direction).toFixed(2);
		} catch (err) {
			//either at the upper or lower limits of available prices.
		}
	}
</script>

<StepInputFloat
	bind:value={newPrice}
	{compact}
	{tabindex}
	inputWidth={width}
	highlight={false}
	bgHighlight={false}
	on:inc={() => setClosest('up')}
	on:dec={() => setClosest('down')}
	on:enter={() => onEnter && onEnter()}
/>
